import { createSelector } from '@reduxjs/toolkit';

const channelsSelector = (state) => state.channels;

const getDateOrderedChannels = createSelector(channelsSelector, (channels) => {
  const sortedChannels = [...channels.data].sort((a, b) => {
    const { channel_type: typeA, updated_at: updatedA } = a;
    const { channel_type: typeB, updated_at: updatedB } = b;

    if (typeA > typeB || updatedB - updatedA) {
      return -1;
    }

    if (typeA < typeB || updatedA - updatedB) {
      return 1;
    }

    return 0;
  });


  return {
    ...channels,
    data: sortedChannels,  //put regional feed back 2021.08.16
  };
});

export default {
   getDateOrderedChannels,
};
